import React from 'react'
import { GuestListTableContainer } from '../../Dashboard/pages/dues/dues.style'
import { PageContainerTitleText } from '../../../widget/styledComponents/headings.style'

function SubadminInnvite() {
  return (
    <div>
        <div className='row'>
            <div className='col s12 m4'></div>
            <div className='col s12 m4'>
                <GuestListTableContainer>
                    <PageContainerTitleText>
                        Asset management invite
                    </PageContainerTitleText>
                    <hr/>

                    
                </GuestListTableContainer>
            </div>
            <div className='col s12 m4'></div>
        </div>
    </div>
  )
}

export default SubadminInnvite